import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../../app/SliceUtils";

export const fetchSubscriptions = createAsyncThunk(
    '/api/subscription/subscriptions/performanceId',
    (performanceId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/subscription/subscriptions/${performanceId}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const postSubscriptions = createAsyncThunk(
    '/api/subscription/post',
    (newSubscriptions, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/subscription`, method: 'POST', body: newSubscriptions }, rejectWithValue)
);

export const putSubscriptions = createAsyncThunk(
    '/api/subscription/put',
    (updatedSubscriptions, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/subscription`, method: 'PUT', body: updatedSubscriptions }, rejectWithValue)
);

export const deleteSubscriptions = createAsyncThunk(
    '/api/subscription/delete',
    (unsubscriptions, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/subscription`, method: 'DELETE', body: unsubscriptions }, rejectWithValue)
);

export const fetchUnsubscriptions = createAsyncThunk(
    '/api/subscription/unsubscriptions/performanceId',
    (performanceId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/subscription/unsubscriptions/${performanceId}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchPerformancesForMove = createAsyncThunk(
    '/api/subscription/move/performances/activityId',
    ({ currentPerformanceId, departmentId, activityId }, { rejectWithValue }) =>
        ApiFetch({
            endpoint: activityId ?
                `api/subscription/move/performances/${currentPerformanceId}/${departmentId}/${activityId}` :
                `api/subscription/move/performances/${currentPerformanceId}/${departmentId}`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const postSubscriptionsMove = createAsyncThunk(
    '/api/subscription/move/post',
    (subscriptionMoveList, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/subscription/move`, method: 'POST', body: subscriptionMoveList }, rejectWithValue)
);

export const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState: {
        subscriptions: { data: null, status: null },
        subscriptionsPost: { data: null, status: null },
        subscriptionsPut: { data: null, status: null },
        subscriptionsDelete: { data: null, status: null },
        unsubscriptions: { data: null, status: null },
        movePerformances: { data: null, status: null },
        moveSubscriptions: { data: null, status: null },
    },
    reducers: {
        resetSubscriptionStatus: (state) => {
            ResetSliceState(state);
        }
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchSubscriptions, 'subscriptions');
        CreateAsyncStatusHandler(builder, postSubscriptions, 'subscriptionsPost');
        CreateAsyncStatusHandler(builder, putSubscriptions, 'subscriptionsPut');
        CreateAsyncStatusHandler(builder, deleteSubscriptions, 'subscriptionsDelete');
        CreateAsyncStatusHandler(builder, fetchUnsubscriptions, 'unsubscriptions');
        CreateAsyncStatusHandler(builder, fetchPerformancesForMove, 'movePerformances');
        CreateAsyncStatusHandler(builder, postSubscriptionsMove, 'moveSubscriptions');
    }
});

export const { resetSubscriptionStatus } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;